export default __webpack_public_path__ + "static/media/level_4.8260d110.jpg";